import { render, staticRenderFns } from "./MonitorPermissionList.vue?vue&type=template&id=1b491e2c&"
import script from "./MonitorPermissionList.vue?vue&type=script&lang=js&"
export * from "./MonitorPermissionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports